import { Typography } from '@mui/material';
import DashboardsList from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardsList';
import DashboardsModal from '@src/main/ui/components/common/Dashboard/DashboardModal/DashboardModal';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';
import { type FC } from 'react';

const Home: FC = () => {
  const { dashboards } = useDashboardContext();
  const { user } = useUserContext();

  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px' }}>
        Dashboards Portal
      </Typography>
      {dashboards &&
        [
          {
            title: 'Most Visited',
            dashboards: dashboards
              .slice()
              .sort((a, b) => (b.views || 0) - (a.views || 0))
              .slice(0, 6),
          },
          {
            title: 'Recently Opened',
            dashboards: dashboards
              .filter((dashboard) => user?.recentlyOpened.includes(dashboard.id))
              .slice()
              .sort(
                (a, b) =>
                  (user?.recentlyOpened || []).indexOf(a.id) -
                  (user?.recentlyOpened || []).indexOf(b.id),
              ),
          },
          {
            title: 'Recommended',
            dashboards: dashboards
              .filter((dashboard) => user?.recommended.includes(dashboard.id))
              .slice()
              .sort(
                (a, b) =>
                  (user?.recommended || []).indexOf(a.id) - (user?.recommended || []).indexOf(b.id),
              ),
          },
          {
            title: 'Favorites',
            dashboards: dashboards.filter((dashboard) => user?.favorites.includes(dashboard.id)),
          },
          {
            title: 'Recently Added',
            dashboards: dashboards
              .filter((dashboard) => {
                const date = new Date();
                date.setDate(date.getDate() - 7);
                return dashboard.createdAt > date;
              })
              .slice()
              .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
              .slice(0, 10),
          },
        ].map((item) => (
          <DashboardsList
            key={item.title}
            title={item.title}
            dashboards={item.dashboards}
            actions={{
              favorite: true,
              info: true,
            }}
            isExpandable
          />
        ))}

      <DashboardsModal />
    </>
  );
};

export default Home;
